(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ctw-colour-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  function initGallery(scope) {
    scope.querySelectorAll('[data-colour-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const panels = [...gallery.querySelectorAll('[data-colour-panel]')];
      const buttons = [...gallery.querySelectorAll('[data-colour-select]')];
      const refresh = new Map();
      gallery.querySelector('[data-colour-tabs]').hidden = false;
      panels.forEach(panel => {
        const track = panel.querySelector('[data-colour-track]');
        const slides = [...track.children];
        const prev = panel.querySelector('[data-colour-prev]');
        const next = panel.querySelector('[data-colour-next]');
        const count = panel.querySelector('[data-colour-count]');
        panel.querySelector('[data-colour-controls]').hidden = false;
        function update() {
          if (panel.hidden || !slides.length) return;
          const step = slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
          const index = Math.min(slides.length - 1, Math.round(track.scrollLeft / step));
          count.textContent = `${index + 1} / ${slides.length}`;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        }
        function move(direction) {
          const step = slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
          track.scrollBy({left:direction * step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }
        prev.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', update, {passive:true});
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        });
        refresh.set(panel, update);
        if (typeof ResizeObserver !== 'undefined') new ResizeObserver(update).observe(track);
      });
      function select(colour) {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.colourSelect === colour)));
        panels.forEach(panel => {
          panel.hidden = panel.dataset.colourPanel !== colour;
          if (!panel.hidden) requestAnimationFrame(refresh.get(panel));
        });
      }
      buttons.forEach(button => button.addEventListener('click', () => select(button.dataset.colourSelect)));
      select(buttons[0].dataset.colourSelect);
      document.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-colour-panel]');
        if (panel && gallery.contains(panel)) select(panel.dataset.colourPanel);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initGallery(document));
  else initGallery(document);
  document.addEventListener('shopify:section:load', event => initGallery(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
